/**
 * Tiny status pill for shop cards / lists. Use when you've already
 * fetched stock rows for many products and just want a single best-status
 * indicator per card.
 *
 * Pass either:
 *   - rows: full array of stock rows for this SKU (from website_stock_public), OR
 *   - status: a single pre-computed status string
 */

const ORDER = { in_stock: 3, low_stock: 2, out_of_stock: 1 };

const STYLES = {
  in_stock: { label: "In stock", className: "bg-emerald-500" },
  low_stock: { label: "Low stock", className: "bg-amber-500" },
  out_of_stock: { label: "Out of stock", className: "bg-red-500" },
};

function normalize(raw) {
  const v = String(raw || "").toLowerCase().replace(/[\s-]+/g, "_");
  if (v === "in_stock" || v === "available" || v === "in") return "in_stock";
  if (v === "low_stock" || v === "low") return "low_stock";
  if (v === "out_of_stock" || v === "out" || v === "unavailable" || v === "sold_out") return "out_of_stock";
  return null;
}

export function bestStatusFromRows(rows = []) {
  let best = null;
  for (const r of rows) {
    const s = normalize(r.stock_status);
    if (!s) continue;
    if (!best || ORDER[s] > ORDER[best]) best = s;
  }
  return best;
}

export default function StockStatusBadge({ rows, status, size = "sm" }) {
  const s = status || bestStatusFromRows(rows);
  if (!s) return null;
  const def = STYLES[s];
  if (!def) return null;
  const px = size === "sm" ? "px-2 py-0.5 text-[10px]" : "px-2.5 py-1 text-xs";
  return (
    <span
      data-testid={`stock-badge-${s}`}
      className={`inline-flex items-center gap-1 ${px} text-white font-semibold rounded-full ${def.className}`}
    >
      <span className="w-1.5 h-1.5 rounded-full bg-white/90" />
      {def.label}
    </span>
  );
}
